import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { IKompisTranslations } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { registerIcon, warningTriangle } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import { InlineMessage as SkapaInlineMessage } from '@ingka/inline-message-webc/passive.js';

/**
 * US Injury or Death Warning is used for ranges where there is a risk of tipping over if not fastened to the wall, in the US market. This message is displayed in relevant Kompis components.
 *
 * @event click Triggered when button is clicked.
 */
export default class InjuryOrDeathWarning extends KompisElement {
	// The translations retrieved from translations service.
	@property({ type: Object })
	public translations: IKompisTranslations;

	public override async connectedCallback(): Promise<void> {
		registerIcon(warningTriangle);

		this.customElements.define('skapa-inline-message', SkapaInlineMessage);
		this.customElements.define('skapa-icon', SkapaIcon);

		super.connectedCallback();
	}

	public override render(): RenderResult {
		const { injuryOrDeathWarningTitle, injuryOrDeathWarningBody } = this.translations;

		return html`
			<skapa-inline-message variant="cautionary">
				<skapa-icon slot="message-icon" icon="warning-triangle"></skapa-icon>
				<span slot="title">${injuryOrDeathWarningTitle}</span>
				<span slot="body">${injuryOrDeathWarningBody}</span>
			</skapa-inline-message>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-injury-or-death-warning': InjuryOrDeathWarning;
		'skapa-inline-message': SkapaInlineMessage;
		'skapa-icon': SkapaIcon;
	}
}
